import Head from 'next/head'
import { includes } from 'lodash'
import { useRouter } from 'next/router'

import { useAppSelector } from 'app-redux/hooks'

import { selectCommanders } from 'app-redux/deck/selectors'

import { CardType, EDH_FORMATS } from 'types/deck'

import DesktopDeckHeader from 'components/deckPage/header/DeckHeader/Desktop'
import MobileDeckHeader from 'components/deckPage/header/DeckHeader/Mobile'

import { useGetDeckHeaderArt, useGetFormatName, useGetSpecialDeckName } from './useGetHeaderInfo'

import styles from './deckHeader.module.scss'

const DeckHeader = () => {
  const router = useRouter()

  const cardMap = useAppSelector(state => state.deck.cardMap)
  const commanders = useAppSelector(selectCommanders)
  const format = useAppSelector(state => state.deck.format)
  const formatName = useGetFormatName()
  const owner = useAppSelector(state => state.deck.owner)

  const updatedAt = useAppSelector(state => state.deck.updatedAt)

  const cardBannerUrl = useGetDeckHeaderArt()

  let faceCard: CardType | null = null
  let isCommanderFormat = includes(EDH_FORMATS, format)

  if (isCommanderFormat) faceCard = commanders[0] ? cardMap[commanders[0]] : null

  return (
    <>
      <Head>
        {/* THESE TWO ARE INTENTIONALLY LEFT OFF. They're enabled by the default headers component which is envoked via the <PageWrapper /> and <Headers /> components */}
        {/* <meta property="og:title" content={title} /> */}
        {/* <meta property="og:description" content={description} /> */}
        <meta property="og:url" content={router.asPath} />
        <meta property="og:type" content="article" />
        <meta property="article:published_time" content={updatedAt} />
        <meta property="article:author" content={owner === 'Archidekt_Precons' ? 'Archidekt Precons' : owner} />
        <meta property="og:image" content={cardBannerUrl} />
        {/* <meta property="og:image:width" content="764" /> */}
        {/* <meta property="og:image:height" content="430" /> */}
        {/* <meta property="og:image:type" content="image/jpeg" /> */}
        <meta name="author" content={owner === 'Archidekt_Precons' ? 'Archidekt Precons' : owner} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:label1" content="Created by" />
        <meta name="twitter:data1" content={owner} />
        <meta name="twitter:label2" content="Format" />
        <meta name="twitter:data2" content={formatName} />
        <meta name="twitter:image" content={cardBannerUrl} />
      </Head>

      <DesktopDeckHeader className={styles.desktop} />
      <MobileDeckHeader className={styles.mobile} />
    </>
  )
}

export default DeckHeader
